window.addEventListener("phx:add-class", (e) => {
  const el = document.getElementById(e.detail.id);

  if (el) {
    el.classList.add(e.detail.class);
  }
});

window.addEventListener("phx:remove-class", (e) => {
  const el = document.getElementById(e.detail.id);

  if (el) {
    el.classList.remove(e.detail.class);
  }
});

// NOTE: This may not work due to browser security/settings. We will need to keep watch on this,
// ensuring it's not an issue. If it is, we'll need to discover another way to handle this.
// This was added for the purpose of table exports; so that when a user clicks export, the page
// does not redirect to the export URL, taking them away from the page/table.
window.addEventListener("phx:redirect-new-window", (e) => {
  const { url } = e.detail;
  const newWindow = window.open(url, "_blank");

  newWindow.focus();
});

// Lookup: Copy to clipboard
window.addEventListener("phx:clipcopy", (event) => {
  if ("clipboard" in navigator) {
    const text = event.detail.value;
    navigator.clipboard.writeText(text);

    const noticeTextContainer = document
      .getElementById(event.detail.dispatcher.id)
      .closest("div:has(.lookup)")
      .querySelector(".copy-selection-details");
    noticeTextContainer.innerHTML = `Copied to your clipboard: <b>${text}</b>`;
  }
});
